import {
    CANDIDATE_CALL_END,
    CANDIDATE_CALL_END_FAILURE,
    CANDIDATE_CALL_END_SUCCESS,
    CANDIDATE_CALL_START,
    CANDIDATE_CALL_START_FAILURE,
    CANDIDATE_CALL_START_SUCCESS,
    CLEAR_CANDIDATE_DETAILS,
    CLEAR_CANDIDATE_FORM_DRAFT,
    COMPARE_JD_CV,
    COMPARE_JD_CV_FAILURE,
    COMPARE_JD_CV_SUCCESS,
    CONTACT_ADMIN,
    CONTACT_ADMIN_FAILURE,
    CONTACT_ADMIN_SUCCESS,
    CREATE_AND_UPDATE_SCREENSHOT,
    CREATE_AND_UPDATE_SCREENSHOT_FAILURE,
    CREATE_AND_UPDATE_SCREENSHOT_SUCCESS,
    CREATE_CODE_SUBMISSION,
    CREATE_CODE_SUBMISSION_FAILURE,
    CREATE_CODE_SUBMISSION_SUCCESS,
    FACE_EXPRESSION,
    FACE_EXPRESSION_FAILURE,
    FACE_EXPRESSION_SUCCESS,
    FETCH_SCREENSHOT_IMAGE,
    FETCH_SCREENSHOT_IMAGE_FAILURE,
    FETCH_SCREENSHOT_IMAGE_SUCCESS,
    FULL_FACE_DETECTION,
    FULL_FACE_DETECTION_FAILURE,
    FULL_FACE_DETECTION_NEW,
    FULL_FACE_DETECTION_NEW_FAILURE,
    FULL_FACE_DETECTION_NEW_SUCCESS,
    FULL_FACE_DETECTION_SUCCESS,
    GET_CANDIDATE_DETAILS_USING_RESUME,
    GET_CANDIDATE_DETAILS_USING_RESUME_FAILURE,
    GET_CANDIDATE_DETAILS_USING_RESUME_SUCCESS,
    GET_CONVERSION_REPORT,
    GET_CONVERSION_REPORT_FAILURE,
    GET_CONVERSION_REPORT_SUCCESS,
    GET_INTERVIEW,
    GET_INTERVIEW_FAILURE,
    GET_INTERVIEW_SUCCESS,
    GET_INTERVIEW_TOKEN,
    GET_INTERVIEW_TOKEN_FAILURE,
    GET_INTERVIEW_TOKEN_SUCCESS,
    GET_QUESTION,
    GET_QUESTION_FAILURE,
    GET_QUESTION_NUMBER,
    GET_QUESTION_NUMBER_FAILURE,
    GET_QUESTION_NUMBER_SUCCESS,
    GET_QUESTION_SUCCESS,
    GET_SESSION_TOKEN,
    GET_SESSION_TOKEN_FAILURE,
    GET_SESSION_TOKEN_SUCCESS,
    INTERVIEW_FEEDBACK_STATUS,
    INTERVIEW_FEEDBACK_STATUS_FAILURE,
    INTERVIEW_FEEDBACK_STATUS_SUCCESS,
    LIVE_KIT_TOKEN,
    LIVE_KIT_TOKEN_FAILURE,
    LIVE_KIT_TOKEN_SUCCESS,
    LOOKING_FORWARD,
    LOOKING_FORWARD_FAILURE,
    LOOKING_FORWARD_SUCCESS,
    MOVEMENT,
    MOVEMENT_FAILURE,
    MOVEMENT_SUCCESS,
    NOTIFICATION_ERROR,
    NOTIFICATION_ERROR_FAILURE,
    NOTIFICATION_ERROR_SUCCESS,
    POST_CANDIDATE,
    POST_CANDIDATE_FAILURE,
    POST_CANDIDATE_SUCCESS,
    POST_CONSENT,
    POST_CONSENT_FAILURE,
    POST_CONSENT_SUCCESS,
    POST_INTERVIEW_FEEDBACK,
    POST_INTERVIEW_FEEDBACK_FAILURE,
    POST_INTERVIEW_FEEDBACK_SUCCESS,
    POST_INTERVIEW_STATUS,
    POST_INTERVIEW_STATUS_FAILURE,
    POST_INTERVIEW_STATUS_SUCCESS,
    PRACTICE_QUESTION,
    PRACTICE_QUESTION_FAILURE,
    PRACTICE_QUESTION_SUCCESS,
    PRACTICE_QUESTION_UPDATE,
    PRACTICE_QUESTION_UPDATE_FAILURE,
    PRACTICE_QUESTION_UPDATE_SUCCESS,
    REMOVE_SCREENSHOT_IMAGE,
    RESEND_OTP_REQUEST,
    RESEND_OTP_REQUEST_FAILURE,
    RESEND_OTP_REQUEST_SUCCESS,
    RESET_CODE_SUBMISSION_OUTPUT,
    SCREEN_SHARE_VID,
    SET_CANDIDATE_FORM_DRAFT,
    SUBMIT_CEFR,
    SUBMIT_CEFR_FAILURE,
    SUBMIT_CEFR_SUCCESS,
    SUBMIT_CODING_QUESTION,
    SUBMIT_CODING_QUESTION_FAILURE,
    SUBMIT_CODING_QUESTION_SUCCESS,
    SUBMIT_MCQ,
    SUBMIT_MCQ_FAILURE,
    SUBMIT_MCQ_SUCCESS,
    SUBMIT_TRANSCRIBE,
    SUBMIT_TRANSCRIBE_FAILURE,
    SUBMIT_TRANSCRIBE_SUCCESS,
    SWITCH_TAB,
    SWITCH_TAB_FAILURE,
    SWITCH_TAB_SUCCESS,
    UPDATE_CONVERSATION_QUESTION,
    UPDATE_CONVERSATION_QUESTION_FAILURE,
    UPDATE_CONVERSATION_QUESTION_SUCCESS,
    UPDATE_TRANSCRIPT,
    UPDATE_TRANSCRIPT_FAILURE,
    UPDATE_TRANSCRIPT_SUCCESS,
    UPLOAD_CANDIDATE_VIDEO,
    UPLOAD_CANDIDATE_VIDEO_FAILURE,
    UPLOAD_CANDIDATE_VIDEO_SUCCESS,
    UPLOAD_CEFR_VIDEO,
    UPLOAD_VIDEO,
    USING_LIVEKIT_SDK,
    VERIFY_CANDIDATE_KEY,
    VERIFY_CANDIDATE_KEY_FAILURE,
    VERIFY_CANDIDATE_KEY_SUCCESS,
    VERIFY_ROOM,
    VERIFY_ROOM_FAILURE,
    VERIFY_ROOM_SUCCESS,
} from '../action/types';

// WHY THIS EXISTS
// The whitelabel logo only ever lives in this Redux store. It is fetched by verifyRoom on
// the pre-join screens, and no route under /meeting ever fetches it again. A browser reload
// of /preview/candidate therefore starts with an empty store, the header falls back to the
// InCruiter mark, and it stays wrong for the whole interview - which is exactly what the
// proctoring screenshots capture. Mirroring the logo in sessionStorage survives that reload.

// Key is scoped to the interview so a second interview in the same tab cannot inherit the
// first one's logo. The 24-hex id is the roomId in /meeting|/preview/<role>/<roomId>.
const wlKey = () => `wl_${window.location.pathname.match(/[0-9a-f]{24}/)?.[0] || ''}`;

// Read back whatever the previous page load stored for this same room.
const wlRestore = () => {
    try {
        // `|| undefined` so a missing key falls through to the caller's default below.
        return JSON.parse(sessionStorage.getItem(wlKey())) || undefined;
    } catch (e) {
        // Private mode, blocked storage or a corrupt value must never break app start-up.
        return undefined;
    }
};

const INIT_STATE = {
    apiFailure: false,
    loading: false,
    screenshot: null,
    question: null,
    interviewToken: null,
    interview: null,
    verifyKey: null,
    fetchImage: null,
    resendOtp: null,
    roomVerifyStatus: null,
    interviewFeedbackStatusDetails: null,
    hasFullFaceDetected: false,
    hasFullFaceDetectedNew: false,
    fetchingWhiteLabelStatus: false,
    // Restored on a reload; falls back to the original empty value on a genuinely new tab,
    // so a client with no logo still shows the InCruiter mark exactly as before.
    whiteLabelLogos: wlRestore() || { whiteLogo: '', logo: '' },
    submitLoading: false,
    codeSubmissionOutput: null,
    verifyLoading: false,
    screenshotImage: null,
    lastQuestionSubmitTimeStampAptitude: null,
    screenShareVid: false,
    autoInviteConfig: null,
    compareData: 0,
    compareLoading: false,
    candidateDetails: null,
    candidateFormDraft: null,
    conversionReport: null,
    dynamicLink: { expires: null, signature: null },
    statusLinkExpired: false,
    companyInfo: null,
    usingLiveKitSDK: false,
};

const Interview = (state = INIT_STATE, action) => {
    switch (action.type) {
        case FACE_EXPRESSION:
            return { ...state, loading: false };
        case FACE_EXPRESSION_SUCCESS:
            return { ...state, loading: false };
        case FACE_EXPRESSION_FAILURE:
            return { ...state, loading: false };

        case UPLOAD_CANDIDATE_VIDEO:
            return { ...state, loading: false };
        case UPLOAD_CANDIDATE_VIDEO_SUCCESS:
            return { ...state, loading: false };
        case UPLOAD_CANDIDATE_VIDEO_FAILURE:
            return { ...state, loading: false };

        case GET_SESSION_TOKEN:
            return { ...state, loading: false };
        case GET_SESSION_TOKEN_SUCCESS:
            return { ...state, loading: false };
        case GET_SESSION_TOKEN_FAILURE:
            return { ...state, loading: false };

        case UPDATE_TRANSCRIPT:
            return { ...state, loading: false };
        case UPDATE_TRANSCRIPT_SUCCESS:
            return { ...state, loading: false };
        case UPDATE_TRANSCRIPT_FAILURE:
            return { ...state, loading: false };

        case LIVE_KIT_TOKEN:
            return { ...state, loading: true };
        case LIVE_KIT_TOKEN_SUCCESS:
            return { ...state, loading: false };
        case LIVE_KIT_TOKEN_FAILURE:
            return { ...state, loading: false };

        case UPDATE_CONVERSATION_QUESTION:
            return { ...state, loading: false };
        case UPDATE_CONVERSATION_QUESTION_SUCCESS:
            return { ...state, loading: false };
        case UPDATE_CONVERSATION_QUESTION_FAILURE:
            return { ...state, loading: false };

        case NOTIFICATION_ERROR:
            return { ...state, loading: true };
        case NOTIFICATION_ERROR_SUCCESS:
            return { ...state, loading: false };
        case NOTIFICATION_ERROR_FAILURE:
            return { ...state, loading: false };

        case PRACTICE_QUESTION:
            return { ...state, loading: false };
        case PRACTICE_QUESTION_SUCCESS:
            return { ...state, loading: false };
        case PRACTICE_QUESTION_FAILURE:
            return { ...state, loading: false };

        case PRACTICE_QUESTION_UPDATE:
            return { ...state, loading: false };
        case PRACTICE_QUESTION_UPDATE_SUCCESS:
            return { ...state, loading: false };
        case PRACTICE_QUESTION_UPDATE_FAILURE:
            return { ...state, loading: false };

        case INTERVIEW_FEEDBACK_STATUS:
            return { ...state, loading: true, fetchingWhiteLabelStatus: true };
        case INTERVIEW_FEEDBACK_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                interviewFeedbackStatusDetails: action.payload,
                fetchingWhiteLabelStatus: false,
                whiteLabelLogos: action.payload.checkWhiteLabelledStatus.whiteLabelStatus
                    ? {
                          whiteLogo: action.payload.checkWhiteLabelledStatus.data.companyWhiteLogo,
                          logo: action.payload.checkWhiteLabelledStatus.data.companyLogo,
                      }
                    : {
                          whiteLogo: '',
                          logo: '',
                      },
            };
        case INTERVIEW_FEEDBACK_STATUS_FAILURE:
            return { ...state, loading: false, fetchingWhiteLabelStatus: true };

        case SUBMIT_TRANSCRIBE:
            return { ...state, loading: false };
        case SUBMIT_TRANSCRIBE_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case SUBMIT_TRANSCRIBE_FAILURE:
            return { ...state, loading: false };

        case MOVEMENT:
            return { ...state, loading: true };
        case MOVEMENT_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case MOVEMENT_FAILURE:
            return { ...state, loading: false };

        case CREATE_AND_UPDATE_SCREENSHOT:
            return { ...state, loading: true };
        case CREATE_AND_UPDATE_SCREENSHOT_SUCCESS:
            return {
                ...state,
                loading: false,
                screenshot: action.payload,
            };
        case CREATE_AND_UPDATE_SCREENSHOT_FAILURE:
            return { ...state, loading: false };

        case SWITCH_TAB:
            return { ...state, loading: false };
        case SWITCH_TAB_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case SWITCH_TAB_FAILURE:
            return { ...state, loading: false };

        case CANDIDATE_CALL_START:
            return { ...state, loading: true };
        case CANDIDATE_CALL_START_FAILURE:
            return {
                ...state,
                loading: false,
                apiFailure: CANDIDATE_CALL_START,
            };
        case CANDIDATE_CALL_START_SUCCESS:
            return {
                ...state,
                loading: false,
                verifyKey: null,
                roomVerifyStatus: null,
                candidateCallStartResponse: action.payload,
            };
        case VERIFY_CANDIDATE_KEY:
            return { ...state, verifyLoading: true };
        case VERIFY_CANDIDATE_KEY_SUCCESS:
            return {
                ...state,
                verifyLoading: false,
                verifyKey: action.payload,
            };
        case VERIFY_CANDIDATE_KEY_FAILURE:
            return { ...state, verifyLoading: false, apiFailure: VERIFY_CANDIDATE_KEY };
        case VERIFY_ROOM:
            return { ...state, loading: true, fetchingWhiteLabelStatus: true };
        case VERIFY_ROOM_SUCCESS:
            return {
                ...state,
                loading: false,
                roomVerifyStatus: action.payload,
                fetchingWhiteLabelStatus: false,
                companyInfo: action.payload.companyInfo,
                whiteLabelLogos: action.payload.checkWhiteLabelledStatus.whiteLabelStatus
                    ? {
                          whiteLogo: action.payload.checkWhiteLabelledStatus.data.companyWhiteLogo,
                          logo: action.payload.checkWhiteLabelledStatus.data.companyLogo,
                      }
                    : {
                          whiteLogo: '',
                          logo: '',
                      },
            };
        case VERIFY_ROOM_FAILURE:
            return { ...state, loading: false, apiFailure: VERIFY_ROOM, fetchingWhiteLabelStatus: true };
        case GET_QUESTION_NUMBER:
            return { ...state, loading: true };
        case GET_QUESTION_NUMBER_SUCCESS:
            return {
                ...state,
                loading: false,
                questionNumber: action.payload?.completedQuestions || 0,
                lastQuestionSubmitTimeStampAptitude: action.payload?.lastQuestionSubmitTimeStampAptitude || null,
            };
        case GET_QUESTION_NUMBER_FAILURE:
            return { ...state, loading: false, apiFailure: GET_QUESTION_NUMBER };
        case GET_QUESTION:
            return { ...state, loading: true };
        case GET_QUESTION_SUCCESS:
            return {
                ...state,
                loading: false,
                question: action.payload,
            };
        case GET_QUESTION_FAILURE:
            return { ...state, loading: false, apiFailure: GET_QUESTION };

        case POST_INTERVIEW_STATUS:
            return { ...state, loading: true };
        case POST_INTERVIEW_STATUS_SUCCESS:
            return { ...state, loading: false };
        case POST_INTERVIEW_STATUS_FAILURE:
            return { ...state, loading: false, apiFailure: POST_INTERVIEW_STATUS };

        case CANDIDATE_CALL_END:
            return { ...state, loading: true };
        case CANDIDATE_CALL_END_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case CANDIDATE_CALL_END_FAILURE:
            return { ...state, loading: false };

        case REMOVE_SCREENSHOT_IMAGE:
            return {
                ...state,
                loading: false,
                fetchImage: null,
            };

        case FETCH_SCREENSHOT_IMAGE:
            return {
                ...state,
                loading: false,
                fetchImage: null,
            };
        case FETCH_SCREENSHOT_IMAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                fetchImage: action.payload,
            };
        case FETCH_SCREENSHOT_IMAGE_FAILURE:
            return { ...state, loading: false };

        case GET_INTERVIEW_TOKEN:
            return { ...state, loading: true, fetchingWhiteLabelStatus: true };
        case GET_INTERVIEW_TOKEN_SUCCESS:
            return {
                ...state,
                loading: false,
                interviewToken: action.payload,
                fetchingWhiteLabelStatus: false,
                whiteLabelLogos: action.payload.checkWhiteLabelledStatus.whiteLabelStatus
                    ? {
                          whiteLogo: action.payload.checkWhiteLabelledStatus.data.companyWhiteLogo,
                          logo: action.payload.checkWhiteLabelledStatus.data.companyLogo,
                      }
                    : {
                          whiteLogo: '',
                          logo: '',
                      },
            };
        case GET_INTERVIEW_TOKEN_FAILURE:
            return { ...state, loading: false, apiFailure: GET_INTERVIEW_TOKEN, fetchingWhiteLabelStatus: true };

        case GET_INTERVIEW:
            return { ...state, loading: true, fetchingWhiteLabelStatus: true };
        case GET_INTERVIEW_SUCCESS:
            return {
                ...state,
                loading: false,
                interview: action.payload,
                fetchingWhiteLabelStatus: false,
                whiteLabelLogos: action.payload.employer.checkWhiteLabelledStatus.whiteLabelStatus
                    ? {
                          whiteLogo: action.payload.employer.checkWhiteLabelledStatus.data.companyWhiteLogo,
                          logo: action.payload.employer.checkWhiteLabelledStatus.data.companyLogo,
                      }
                    : {
                          whiteLogo: '',
                          logo: '',
                      },
            };
        case GET_INTERVIEW_FAILURE:
            return {
                ...state,
                loading: false,
                apiFailure: GET_INTERVIEW,
                fetchingWhiteLabelStatus: true,
                statusLinkExpired: true,
            };

        case POST_INTERVIEW_FEEDBACK:
            return { ...state, loading: true };
        case POST_INTERVIEW_FEEDBACK_SUCCESS:
            return { ...state, loading: false };
        case POST_INTERVIEW_FEEDBACK_FAILURE:
            return { ...state, loading: false, apiFailure: POST_INTERVIEW_FEEDBACK };

        case RESEND_OTP_REQUEST:
            return { ...state, loading: false };
        case RESEND_OTP_REQUEST_SUCCESS:
            return { ...state, loading: false, resendOtp: action.payload };
        case RESEND_OTP_REQUEST_FAILURE:
            return { ...state, loading: false, apiFailure: RESEND_OTP_REQUEST };

        case POST_CANDIDATE:
            return { ...state, verifyLoading: true };
        case POST_CANDIDATE_SUCCESS:
            return { ...state, verifyLoading: false };
        case POST_CANDIDATE_FAILURE:
            return { ...state, verifyLoading: false, apiFailure: POST_CANDIDATE };

        case SET_CANDIDATE_FORM_DRAFT:
            return { ...state, candidateFormDraft: action.payload };
        case CLEAR_CANDIDATE_FORM_DRAFT:
            return { ...state, candidateFormDraft: null };

        case CONTACT_ADMIN:
            return { ...state, loading: true };
        case CONTACT_ADMIN_SUCCESS:
            return { ...state, loading: false };
        case CONTACT_ADMIN_FAILURE:
            return { ...state, loading: false };

        case FULL_FACE_DETECTION_NEW:
            return { ...state, loading: true };
        case FULL_FACE_DETECTION_NEW_SUCCESS:
            return { ...state, loading: false, screenshotImage: action.payload };
        case FULL_FACE_DETECTION_NEW_FAILURE:
            return { ...state, loading: false };

        case CREATE_CODE_SUBMISSION:
            return { ...state, submitLoading: true };
        case CREATE_CODE_SUBMISSION_FAILURE:
            return { ...state, submitLoading: false };
        case CREATE_CODE_SUBMISSION_SUCCESS:
            return {
                ...state,
                submitLoading: false,
                codeSubmissionOutput: action?.payload?.result,
            };
        case RESET_CODE_SUBMISSION_OUTPUT:
            return {
                ...state,
                codeSubmissionOutput: null,
            };

        case SUBMIT_CODING_QUESTION:
            return { ...state, submitLoading: action?.payload?.loader };
        case SUBMIT_CODING_QUESTION_SUCCESS:
            return { ...state, submitLoading: false };
        case SUBMIT_CODING_QUESTION_FAILURE:
            return { ...state, submitLoading: false };

        case LOOKING_FORWARD:
        case LOOKING_FORWARD_SUCCESS:
        case LOOKING_FORWARD_FAILURE:
            return { ...state };

        case UPLOAD_VIDEO:
            return { ...state };

        case UPLOAD_CEFR_VIDEO:
            return { ...state };

        case FULL_FACE_DETECTION:
            return { ...state, loading: true };
        case FULL_FACE_DETECTION_SUCCESS:
            return { ...state, loading: false, hasFullFaceDetected: action.payload };
        case FULL_FACE_DETECTION_FAILURE:
            return { ...state, loading: false };

        case SUBMIT_MCQ:
            return { ...state, submitLoading: true };
        case SUBMIT_MCQ_SUCCESS:
            return { ...state, submitLoading: false };
        case SUBMIT_MCQ_FAILURE:
            return { ...state, submitLoading: false };

        case SUBMIT_CEFR:
            return { ...state, submitLoading: true };
        case SUBMIT_CEFR_SUCCESS:
            return { ...state, submitLoading: false };
        case SUBMIT_CEFR_FAILURE:
            return { ...state, submitLoading: false };

        case SCREEN_SHARE_VID:
            return { ...state, screenShareVid: action.payload };

        case COMPARE_JD_CV:
            return { ...state, compareLoading: true, compareData: '0' };
        case COMPARE_JD_CV_SUCCESS:
            return {
                ...state,
                compareLoading: false,
                compareData: action.payload?.matchingPercentage?.toFixed(1) || 0,
            };
        case COMPARE_JD_CV_FAILURE:
            return { ...state, compareLoading: false, compareData: '0' };

        case GET_CANDIDATE_DETAILS_USING_RESUME:
            return { ...state, loading: false };
        case GET_CANDIDATE_DETAILS_USING_RESUME_SUCCESS:
            return { ...state, loading: false, candidateDetails: action.payload };
        case GET_CANDIDATE_DETAILS_USING_RESUME_FAILURE:
            return { ...state, loading: false };
        case CLEAR_CANDIDATE_DETAILS:
            return { ...state, candidateDetails: null };

        case POST_CONSENT:
            return { ...state, loading: true };
        case POST_CONSENT_SUCCESS:
            return { ...state, loading: false };
        case POST_CONSENT_FAILURE:
            return { ...state, loading: false };
        case GET_CONVERSION_REPORT:
            return { ...state, loading: true };
        case GET_CONVERSION_REPORT_SUCCESS:
            return {
                conversionReport: action.payload,
                loading: false,
            };
        case GET_CONVERSION_REPORT_FAILURE:
            return { ...state, loading: false };

        case USING_LIVEKIT_SDK:
            return { ...state, usingLiveKitSDK: action.payload };
        default:
            return state;
    }
};
// Thin wrapper around the reducer above. It never changes what the reducer produces - it only
// notices when the logo has just been learnt and writes it down for the next page load.
const InterviewBranded = (state, action) => {
    // Run the real reducer first; everything below is read-only on its result.
    const next = Interview(state, action);
    const logos = next.whiteLabelLogos;
    // Two guards, both needed:
    //   logos?.whiteLogo             -> only persist a real logo, never an empty one, so a
    //                                   non-whitelabel client stores nothing and is untouched.
    //   logos !== state?.whiteLabelLogos -> only when the reference actually changed, i.e. on the
    //                                   four actions that carry branding. Without this we would
    //                                   write on every single dispatch.
    if (logos?.whiteLogo && logos !== state?.whiteLabelLogos) {
        try {
            sessionStorage.setItem(wlKey(), JSON.stringify(logos));
        } catch (e) {
            // Storage can throw in private mode or when full - the interview must not care.
        }
    }
    // Same object the reducer returned, so connected components see no extra re-render.
    return next;
};
export const getSubmitLoading = (state) => state.Interview.submitLoading;
export const getCodeSubmissionOutput = (state) => state.Interview.codeSubmissionOutput;
export const getUsingLivekitSdk = (state) => state.Interview.usingLiveKitSDK;

export default InterviewBranded;
